module.exports = __webpack_public_path__ + "img/BS_productshop_header_nl.a897c473.png";